import {Component, forwardRef} from "@angular/core";
import {FUIAbstractPill} from "../../framework/abstract-pill";
import {NG_VALUE_ACCESSOR} from "@angular/forms";

@Component({
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FUIPasswordPillComponent),
            multi: true
        }
    ],
    selector: "fui-password-pill",
    styleUrls: ["./password-pill.component.scss"],
    templateUrl: "./password-pill.component.html",
    standalone: false
})
export class FUIPasswordPillComponent extends FUIAbstractPill {
}
